"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../../utils");

var SuccessIcon = require('@tencent/ixd-icons-react/dist').SuccessIcon;

function Render(props) {
  var _a = props.item,
      item = _a === void 0 ? {} : _a;
  var title = item.title,
      titleRight = item.titleRight,
      contentRight = item.contentRight,
      tipList = item.tipList,
      titleSmall = item.titleSmall,
      descList = item.descList,
      signTxt = item.signTxt,
      onCallback = item.onCallback,
      more = item.more,
      moreHref = item.moreHref,
      imgMobile = item.imgMobile;
  var url = (0, _utils.fomateFileData)(imgMobile).url;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: 'brand-equity-card',
    style: url ? {
      background: "url(" + url + ") center no-repeat",
      backgroundSize: 'cover'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("strong", {
    className: 'strong'
  }, titleRight ? titleRight : title), /*#__PURE__*/_react["default"].createElement("p", {
    className: 'p'
  }, contentRight), /*#__PURE__*/_react["default"].createElement("a", {
    className: 'a',
    href: moreHref
  }, more, ' '), /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'ul'
  }, tipList === null || tipList === void 0 ? void 0 : tipList.map(function (tipItem, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "li",
      key: index
    }, tipItem);
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: 'article-p'
  }, titleSmall ? titleSmall : title), /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'list-li'
  }, descList === null || descList === void 0 ? void 0 : descList.map(function (item, index) {
    var txt = (item || {}).txt;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index,
      className: 'li'
    }, /*#__PURE__*/_react["default"].createElement(SuccessIcon, null), txt);
  })), /*#__PURE__*/_react["default"].createElement("button", {
    className: 'but',
    onClick: function onClick() {
      return onCallback && onCallback();
    }
  }, signTxt));
}

var _default = Render;
exports["default"] = _default;